(function ($) {
  $.fn.contactForm = function (options) {
  var cfg = $.extend({
    mainSelector: '[data-contactform]',
    onSuccess: undefined,
    onError: undefined
  }, options);

  var $self = null;
  var $recaptchaToken = '';

  /* --------------------------------------------------------- VALIDATION --- */

  /**
   * Validate and togle error messages
   * @param {object} $form jQuery object of form
   */
  async function validate($form) {
    var valid = true;

    $form.find('[data-contactform-validation]').each(function() {
      var validators = $(this).data('contactform-validation');
      if (validators === undefined || validators === '') {
        return;
      }
      if (!validateInput($(this))) {
        valid = false;
      }
    });

    if (!valid) return valid;
    const recaptchaSiteKey = $self.data('recaptcha-site-key');
    if (!recaptchaSiteKey) return true;

    return new Promise((resolve) => {
      const recaptchaSiteKey = $self.data('recaptcha-site-key');
      if (recaptchaSiteKey) {
        grecaptcha.ready(async () => {
          await grecaptcha.execute(recaptchaSiteKey, {action: 'submit'}).then((token) => {
            $recaptchaToken = token;
            resolve(token ? true : false);
          });
        });
      }
    })
  }

  /**
   * Validate single input
   * @param {object} $input jQuery object of input
   */
  function validateInput($input) {
    var valid = true;
    var errors = [];
    validators = $input.data('contactform-validation').replace(/\s/g, "").split(',');
    for (var i in validators) {
      if (!validateValue($input, validators[i])) {
        valid = false;
        errors.push(getError(validators[i]))
      }
    }
    if (!valid) {
      showErrors($input, errors);
    } else {
      clearErrors($input);
    }
    return valid;
  }

  /**
   * Validate input value
   * @param {object} $input jQuery object of input
   * @param {string} type Validation type name
   */
  function validateValue($input, type) {
    switch (type) {
      case 'required': return validateRequired($input);
      case 'name': return validateName($input);
      case 'phone': return validatePhone($input);
      case 'email': return validateEmail($input);
      case 'contact': return validateContact($input);
      default: return true;
    }
  }

  /**
   * Check if input is filled
   * @param {object} $input jQuery object of input
   */
  function validateRequired($input) {
    if ($input.is('input[type="checkbox"]')) {
      return $input.is(':checked');
    }
    return $input.val() !== '';
  }

  /**
   * Check if input is name (length > 2)
   * @param {object} $input jQuery object of input
   */
  function validateName($input) {
    return $input.val().length > 2;
  }

  /**
   * Check if input is contact phone or email
   * @param {object} $input jQuery object of input
   */
  function validateContact($input) {
    return validatePhone($input) || validateEmail($input);
  }

  /**
   * Check if input is phone (length > 7)
   * @param {object} $input jQuery object of input
   */
  function validatePhone($input) {
    return $input.val().length > 7;
  }

  /**
   * Check if input is email (length > 6)
   * @param {object} $input jQuery object of input
   */
  function validateEmail($input) {
    return $input.val().length > 6;
  }


  /* ------------------------------------------------------------- ERRORS --- */

  /**
   * Get error text depends on validator type
   */
  function getError(type) {
    switch (type) {
      case 'required': return 'To pole jest wymagane';
      case 'name': return 'Pole musi zawierać conajmniej 3 znaki';
      case 'phone': return 'Pole zawiera niepoprawny numer telefonu';
      case 'email': return 'Pole zawiera niepoprawny adres email';
      case 'contact': return 'Niepoprawne dane kontaktowe';
      default: return 'Niepoprawna wartość pola';
    }
  }

  /**
   * Add error list to input
   * @param {object} $input jQuery object of input
   * @param {array} errors List of error messages
   */
  function showErrors($input, errors) {
    clearErrors($input);
    var $parent = $input.parents('label');
    var html = '<ul class="formValidationErrors">';

    $parent.addClass('hasError');
    for (var i in errors) {
      html += '<li>' + errors[i] + '</li>';
      $parent.append(html + '</ul>');
      return;
    }
    $parent.append(html + '</ul>');
  }

  /**
   * Clear error list for input
   * @param {object} $input jQuery object of input
   */
  function clearErrors($input) {
    var $parent = $input.parents('label');
    $parent.removeClass('hasError');
    $parent.find('.formValidationErrors').remove();
  }

  /* -------------------------------------------------------- SUBMIT FORM --- */

  /**
   * Validate and submit if correct
   * @param {object} $form jQuery object of form
   */
  async function tryToSend($form) {
    if (await validate($form)) {
      submitForm($form);
    }
  }

  /**
   * Submit form without validation
   * @param {object} $form jQuery object of form
   */
  function submitForm($form) {
    const startTime = (new Date()).getTime();
    $(cfg.mainSelector).addClass('sending');
    $self.find('[data-contactform-processing]').show();
    $self.find('[data-contactform-success]').hide();
    $self.find('[data-contactform-fail]').hide();

    const formData = new FormData($form.get(0));
    formData.append("recaptcha_token", $recaptchaToken);

    $.ajax({
      method: 'POST',
      url: $form.attr('action'),
      data: formData,
      contentType : false,
      processData : false
    })
    .done(function(res) {
      const { success = false, error = '' } = res;
      const timeDiff = ((new Date()).getTime() - startTime) / 1000;

      setTimeout(() => {
        $self.find('[data-contactform-processing]').hide();
        $(cfg.mainSelector).removeClass('sending');

        if (success) {
          $form.find('[data-contactform-success]').css('display', 'flex').hide().fadeIn();
          if (cfg.onSuccess !== undefined && cfg.onSuccess instanceof Function) {
            cfg.onSuccess();
          }
        } else {
          $form.find('[data-contactform-fail]').css('display', 'flex').hide().fadeIn();
          if (cfg.onError !== undefined && cfg.onError instanceof Function) {
            cfg.onError();
          }
        }
      }, timeDiff < 3000 ? 2000 : 100);

    })
    .fail(function(jqXHR, textStatus) {
      const timeDiff = ((new Date()).getTime() - startTime) / 1000;
      setTimeout(() => {
        $self.find('[data-contactform-processing]').hide();
        $(cfg.mainSelector).removeClass('sending');
        $form.find('[data-contactform-fail]').css('display', 'flex').hide().fadeIn();
          if (cfg.onError !== undefined && cfg.onError instanceof Function) {
            cfg.onError();
          }
      }, timeDiff < 3000 ? 2000 : 100);
    });
  }

  /**
   * Get field data from form
   * @param {object} $input jQuery object of form input
   * @returns {string} Input value
   */
  function fieldData($input) {
    if ($input === undefined) {
      return undefined;
    }
    switch ($input.prop('nodeName')) {
      case 'SELECT':
      case 'TEXTAREA':
      case 'INPUT':
        return $input.val();
      default: return $input.val();
    }
  }

  /* ----------------------------------------------------- INITIALIZATION --- */

  /**
   * Initialize object
   */
  function init() {
    addEvents();
    restoreUrlParams();
    $self.addClass('initialized');
    $self.find('[data-contactform-success]').hide();
    $self.find('[data-contactform-fail]').hide();
    $self.find('[data-contactform-processing]').hide();

    if ($self.find('[data-contactform-currenturl]').length > 0) {
      $self.find('[data-contactform-currenturl]').val(window.location.href);
    }
  }

  function addEvents() {
    $self.find('button[type="submit"]').click(function(e) {
      e.preventDefault();
      tryToSend($(this).parents('form'));
    });

    $self.find('[data-contactform-input]').change(function() {
      var $parent = $(this).parents('label');
      if ($parent.hasClass('hasError')) {
        validateInput($(this));
      }
    });

    $self.find('[data-contactform-input]').keyup(function() {
      var $parent = $(this).parents('label');
      if ($parent.hasClass('hasError')) {
        validateInput($(this));
      }
    });
  }

  function restoreUrlParams() {
    let params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      if ($self.find(`[type="hidden"][name="${key}"]`).length > 0) {
        $self.find(`[type="hidden"][name="${key}"]`).attr('value', value);
      } else {
        $self.append(`<input type="hidden" name="${key}" value="${value}" data-contactform-input data-additional-param>`);
      }
    });
  }

  // Return plugin instances
  return this.each(function () {
    $self = $(this);
    init();
  });
}

}(jQuery));
